import { call, put, takeEvery } from "redux-saga/effects";
import * as Action from "../actions/Actions";
import { getEnvironment } from "../../utils/utils";
import type { IKeyWords, IWebSites } from "../../InterfacesTypes/interfaces";
import { DISPATCHES } from "../../InterfacesTypes/enums";
import { spGet } from "../../utils/SharepointAPI";
import { fetchQuickLinks } from "state/reducers/QuickLinksReducer";
import { fetchImages } from "state/reducers/HeroImageReducer";
import { fetchNavigationItems } from "state/reducers/NavigationItemsReducer";
import { fetchResourceLinks } from "state/reducers/ResourceLinksReducer";
import { fetchFooterSectionImages } from "state/reducers/FooterSectionImagesReducer";
import { fetchRecentlyUpdatedFiles } from "state/reducers/RecentlyUpdatedFilesReducer";
import { fetchCurrentNews } from "state/reducers/CurrentNewsReducer";
import { fetchBannerImage } from "state/reducers/BannerImageReducer";
import { fetchTitleTexts } from "state/reducers/TitleTextReducer";
import { fetchRecentlyUpdatedPages } from "state/reducers/RecentlyUpdatedPagesReducer";

const env = getEnvironment();

function* initializeApplication() {
  //--------- yield call for SP KeyWords list data
  const keyWordsData: IKeyWords[] = yield call(
    spGet,
    `${env.listapi}/getByTitle('KeyWords')/Items?$select=Id,KeyWords,WebSiteURLIDIndex&$top=4999`
  );
  yield put(Action.setSPKeyWordsData(keyWordsData));
  //--------- yield call for SP WebSiteUrls list data
  const webSiteData: IWebSites[] = yield call(
    spGet,
    `${env.listapi}/getByTitle('WebSiteURLs')/Items?$select=Id,URL,WebSiteURLIDIndex,SiteImage,Protected,Title&$top=4999`
  );
  const firstSubDomain = window.location.hostname.split(".")[0];
  yield put(Action.setSPWebSitesData(webSiteData));
  yield put(fetchNavigationItems());
  yield put(fetchResourceLinks());
  yield put(fetchQuickLinks());
  yield put(fetchImages());
  yield put(fetchBannerImage());
  yield put(fetchFooterSectionImages());
  yield put(fetchTitleTexts());
  if (firstSubDomain !== "logistikportalen") {
    yield put(fetchRecentlyUpdatedFiles());
  }
  yield put(fetchRecentlyUpdatedPages());
  yield put(fetchCurrentNews());
}

export function* initializeApplicationSaga() {
  yield takeEvery(DISPATCHES.INITIALIZE_SAGA, initializeApplication);
}
